<template>
  <th scope="col" :class="[
    'px-3 py-2 border-b text-light-50 dark:text-dark-50 whitespace-nowrap border-gray-200 dark:border-gray-700 leading-tight',
    numeric ? 'text-right' : 'text-left'
  ]">
    <slot></slot>
  </th>
</template>

<script>
export default {
  name: 'TableHeadCell',
  props: {
    numeric: {
      type: Boolean,
      default: false
    }
  }
}
</script>
